import './Stack-9e7b935d.css';

var classes = {"Stack":"prc-Stack-Stack-WJVsK","StackItem":"prc-Stack-StackItem-CweWT"};

export { classes as default };
